import React, { useEffect, useState, useCallback } from 'react';
import { useAxios } from '../../../Helpers/AxiosHelper';
import { Button, Column, DataTable, Dialog, ProgressBar } from '../../../Common/Imports';
import { ApiResponse, ReservationCommunications_EXT } from '../../../Models/Classes';
import AppMailDetail from '../../Mail/Detail';
import { ComunicationStatus } from '../../../Models/Enums';
import { ToDateStringNoTime } from '../../../Common/Utility/ToDateStringNoTime';
import { FormatDateTimeFromDate } from '../../../Common/Utility/FormatDateTimeFromDate';

interface OperativeComunicationsProps {
    IDReservation: number;
    OnHide: () => void;
}

export const OperativeComunications: React.FC<OperativeComunicationsProps> = ({ IDReservation, OnHide }) => {
    const AxiosHelper = useAxios();
    const [TableData, SetTableData] = useState<ReservationCommunications_EXT[]>([]);
    const [TableLoader, SetTableLoader] = useState<boolean>(false);
    const [SelectedElement, SetSelectedElement] = useState<ReservationCommunications_EXT | undefined>();


    const GetData = useCallback(async () => {
        SetTableLoader(true);
        try {
            const resp = await AxiosHelper.get<ApiResponse<ReservationCommunications_EXT[]>>(`Operative/GetReservationComunications/${IDReservation}`);
            if (resp.data.code === 0) {
                const processedData = resp.data.data.map(item => ({
                    ...item,
                    datePhoneCall: item.datePhoneCall ? new Date(item.datePhoneCall) : undefined,
                    dateReceiveEmail: item.dateReceiveEmail ? new Date(item.dateReceiveEmail) : undefined,
                    dateSendEmail: item.dateSendEmail ? new Date(item.dateSendEmail) : undefined
                }));
                SetTableData(processedData);
                SetSelectedElement(currentSelection =>
                    currentSelection
                        ? processedData.find(item =>
                            item.idReservationComunication === currentSelection.idReservationComunication)
                        : undefined);
            }
        } catch (error) {
            console.error('Error fetching property contacts:', error);
        } finally {
            SetTableLoader(false);
        }
    }, [AxiosHelper, IDReservation]);

    useEffect(() => {
        GetData();
    }, [GetData]);

    return (
        <Dialog header="Comunications"
            visible={true}
            maximized
            onHide={OnHide}>
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-end mb-3">
                        <Button
                            type="button"
                            label="Refresh"
                            icon="pi pi-refresh"
                            loading={TableLoader}
                            disabled={TableLoader}
                            onClick={GetData}
                            severity="secondary"
                            outlined
                        />
                    </div>

                    {
                        TableLoader ? <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
                            :
                            <DataTable
                                value={TableData}
                                size="small"
                                stripedRows
                                onSelectionChange={(e) => SetSelectedElement(e.value)}
                                selection={SelectedElement}
                                selectionMode="single"
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 20, 50]}
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                sortField="dateSendEmail"
                                sortOrder={-1}
                                tableStyle={{ minWidth: '50rem' }}>
                                <Column
                                    header="status"
                                    field="status"
                                    body={(e: ReservationCommunications_EXT) => { return ComunicationStatus[e.status ?? 9] }}
                                    bodyClassName="table-cell-nowrap" />
                                <Column
                                    header="type"
                                    field="mailType"
                                    body={(e: ReservationCommunications_EXT) => e.mailType === 2 ? "Invoice" : ""}
                                    bodyClassName="table-cell-nowrap" />
                                <Column
                                    header="dateSendEmail"
                                    field="dateSendEmail"
                                    body={(e: ReservationCommunications_EXT) => e.dateSendEmail ? ToDateStringNoTime(e.dateSendEmail) : ""}
                                    bodyClassName="table-cell-nowrap" />
                                <Column
                                    header="dateReceiveEmail"
                                    field="dateReceiveEmail"
                                    body={(e: ReservationCommunications_EXT) => e.dateReceiveEmail ? ToDateStringNoTime(e.dateReceiveEmail) : ""}
                                    bodyClassName="table-cell-nowrap" />
                                <Column
                                    header="datePhoneCall"
                                    field="datePhoneCall"
                                    body={(e: ReservationCommunications_EXT) => FormatDateTimeFromDate(e.datePhoneCall)}
                                    bodyClassName="table-cell-nowrap" />
                                <Column
                                    header="note"
                                    field="note"
                                    bodyClassName="table-cell-nowrap" />
                            </DataTable>
                    }
                </div>
            </div>

            {
                SelectedElement?.idOutlook &&
                <div className="row mt-3">
                    <div className="col-md-12">
                        <AppMailDetail
                            IDOutlook={SelectedElement.idOutlook}
                            ShowSend={false}
                            ShowReservationInfos={true}
                            onChangeComunicationStatus={() => { GetData(); }}
                        ></AppMailDetail>
                    </div>
                </div>
            }

        </Dialog >
    );
};

export default OperativeComunications;
